module.exports = __webpack_public_path__ + "static/years_bubble_large-58c1f92574ddfe82e59662451d6feb44.png";